import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { goBackToHistory } from '../utils/history-navigation-utils';

@Component({
  selector: 'nsl-entity-historyresult',
  templateUrl: './nsl-entity-historyresult.component.html',
  styleUrls: ['./nsl-entity-historyresult.component.scss']
})
export class NSLEntityHistoryResultComponent implements OnInit {

  isSavingRecord;
  individualData = JSON.parse(localStorage.getItem('historyData'))

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  goBack() {
    goBackToHistory(this.location);
  }

}

